import React from 'react';
import Styled from 'styled';

import Modal from 'four-nets/ui-v2/modal/modal';

import defaultStyles from './filter-stack-view.scss';

export interface Props {
    styles: typeof defaultStyles;
    innerRef: any;
    title: React.ReactChild;
    open: boolean;
    onPop: () => void;
}

class FilterStackView extends React.Component<Props> {
    pop = () => {
        if (this.props.onPop) {
            this.props.onPop();
        }
    };

    render() {
        const { styles, title, open } = this.props;

        return (
            <Modal style={{ modal: styles.modal }} title={title} open={open} onClose={this.pop}>
                <div className={styles.wrapper}>{this.props.children}</div>
            </Modal>
        );
    }
}

export default Styled(defaultStyles)(FilterStackView);
